import React from 'react'

import { Region as CoreRegion, Util } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

const { isText, maxLength, minLength } = Util.validations

export const Region = ({ required = true }) => {
  const { getLabel } = useIntl()

  return (
    <CoreRegion
      label={getLabel('checkout.address.district')}
      errorMessage={getLabel('checkout.address.district.errorMessage')}
      validations={[minLength(2), maxLength(50), isText]}
      required={required}
    />
  )
}
